import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { List, useDataGrid } from "@refinedev/mui";
import React from "react";
import { FormControlLabel, Select } from "@mui/material";
import { useState } from "react";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import IncidentAction from "@warriortrading/warriortrading.hermes.common.feathers/enums/incidentAction";

export const MessageIncidentsList = () => {
    const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
        sorters: {
            initial: [
              {
                field: "createdAt",
                order: "desc"
              }
            ]
          },
        pagination: {
            pageSize: 10
        }});
    
    const columns = React.useMemo<GridColumns<any>>(
        () => [
            {
                field: "id",
                headerName: "Id",
                minWidth: 60,
                hideable: false,
            },
            {
                field: "roomId",
                headerName: "RoomId",
                minWidth: 100,
                hideable: false,
            },
            {
                field: "userName",
                headerName: "UserName",
                minWidth: 120,
                hideable: false,
            },
            {
                field: "operatorName",
                headerName: "OperatorName",
                minWidth: 120,
                hideable: false,
            },
            {
                field: "reason",
                headerName: "Reason",
                minWidth: 200,
                flex: 1,
                hideable: false,
            },
            {
                field: "actionType",
                headerName: "Action",
                minWidth: 100,
                hideable: false,
                renderCell: function render({ row }) {
                    return IncidentAction.fromValue(row.actionType)?.name;
                },
            },
            {
                field: "messages",
                headerName: "Messages",
                minWidth: 160,
                flex: 1,
                hideable: false,
                renderCell: function render({ row }) {
                    return <span title={row?.messages[0]?.message} style={{overflow: "hidden", textOverflow: "ellipsis"}}>{row?.messages[0]?.message}</span>
                },
            },
            {
                field: "undoUserName",
                headerName: "UndoUserName",
                minWidth: 140,
                hideable: false,
            },
            {
                field: "createdAt",
                headerName: "CreatedAt",
                minWidth: 160,
                hideable: false,
                renderCell: function render({ row }) {
                    if (row.createdAt) {
                        return new Date(row.createdAt).toLocaleString();
                    } else {
                        return "";
                    }
                },
            },
            {
                field: "undoAt",
                headerName: "UndoAt",
                minWidth: 160,
                hideable: false,
                renderCell: function render({ row }) {
                    if (row.undoAt) {
                        return new Date(row.undoAt).toLocaleString();
                    } else {
                        return "";
                    }
                },
            },
        ],
        [],
    );

    // search parts
    const [userName, setUserName] = useState("");
    const [operatorName, setOperatorName] = useState("");
    const [action, setAction] = useState<any>("");
    const [startDate, setStartDate] = useState<any>(null);
    const [endDate, setEndDate] = useState<any>(null);
    const timeReverse = (date: any) => {
        const Y = date.getFullYear() + '-';
        const M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
        const D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "";
        return Y+M+D;
    }
    const handleFilter = (
    ) => {
        setCurrent(1);
        setPageSize(10);
        let searchArr: {field: string; value: string; operator: string}[] = [];
        if (startDate && endDate && startDate > endDate) {
            window.alert("The startDate cannot laster than the endDate");
            return ;
        }
        if (userName) {
            searchArr.push({
                field: "userName[$ilike]",
                value: `%${userName}%`,
                operator: "eq",
            });
        }
        if (operatorName) {
            searchArr.push({
                field: "operatorName[$ilike]",
                value: `%${operatorName}%`,
                operator: "eq",
            });
        }
        if (action) {
            searchArr.push({
                field: "actionType",
                value: `${action}`,
                operator: "eq",
            });
        } 
        if (startDate) {
            searchArr.push({
                field: "createdAt[$gte]",
                value: `${timeReverse(startDate?.["$d" as any])}`,
                operator: "eq",
            });
        } 
        if (endDate) {
            searchArr.push({
                field: "createdAt[$lte]",
                value: `${timeReverse(endDate?.["$d" as any])}`,
                operator: "eq",
            });
        }
        setFilters(searchArr as any);
    };

    const clearFun = () => {
        setUserName("");
        setOperatorName("");
        setAction("");
        setStartDate(null);
        setEndDate(null);
    }
    return (
        <List>
            <FormControlLabel
                label=""
                style={{width: "100%"}}
                control={
                    <div style={{width: "100%"}}>
                        <div style={{display:"flex", justifyContent: "space-between", alignItems: "flex-end", width: "100%", marginLeft: "19px", paddingRight: "15px", marginBottom: "12px"}}>
                            <TextField id="standard-basic" label="UserName" variant="standard" value={userName} onChange={(e) => setUserName(e.target.value)} style={{width: "30%"}}/>
                            <TextField id="standard-basic" label="OperatorName" variant="standard" value={operatorName} onChange={(e) => setOperatorName(e.target.value)} style={{width: "30%"}}/>
                            <FormControl style={{width: "30%"}}>
                                <InputLabel id="action">Action : </InputLabel>
                                <Select
                                    labelId="action"
                                    value={action as any}
                                    label="Action"
                                    variant="standard"
                                    onChange={(event: SelectChangeEvent) => {
                                        setAction(event.target.value as any);
                                    }}
                                >
                                    {
                                        Object.values(IncidentAction)[0].map((item: any) => {
                                            return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{display:"flex", justifyContent: "space-between", alignItems: "flex-end", width: "100%", marginLeft: "19px", paddingRight: "15px", marginBottom: "12px"}}>
                            <DatePicker label="StartDate" value={startDate}
                                slotProps = {{ textField: { style: {width: "30%"} } }}
                                onChange={(newValue) => {
                                    setStartDate(newValue);
                                }}
                            />
                            <DatePicker label="EndDate" value={endDate}
                                slotProps = {{ textField: { style: {width: "30%"} } }}
                                onChange={(newValue) => {
                                    setEndDate(newValue);
                                }}
                            />
                            <div style={{width: "30%", paddingBottom: "7px"}}>
                                <ClearOutlinedIcon onClick={clearFun}/>
                                <SearchIcon onClick={handleFilter}/>
                            </div>
                        </div>
                    </div>
                }
            />
            <DataGrid {...dataGridProps} columns={columns} autoHeight paginationMode="server" rowsPerPageOptions={[10,20,50]} disableColumnFilter/>
        </List>
    );
};
